export const ArrowIcon = () => {
  return (
    <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.2259 11.2283L2.31682 0.319518C1.89085 -0.106518 1.20009 -0.106518 0.774054 0.319591C0.34809 0.745627 0.34809 1.43632 0.774126 1.86235L10.9118 11.9998L0.774054 22.1378C0.34809 22.5638 0.34809 23.2545 0.774126 23.6805C0.987072 23.8936 1.26627 24 1.54547 24C1.82467 24 2.10387 23.8936 2.31689 23.6805L13.2259 12.7711C13.4306 12.5665 13.5455 12.289 13.5455 11.9997C13.5455 11.7104 13.4306 11.4329 13.2259 11.2283Z"
        fill="white"
      />
    </svg>
  );
};
